export const RESPONDENT_IMPACT_TAG = '/api/materiality-assessment/respondent-impact';
export default RESPONDENT_IMPACT_TAG;
